export default "__VITE_ASSET__ea6dd646__"